/**
 * Created by jv on 19/07/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");

let UserServices = {};

((UserServices) =>
{
  UserServices.getAuthenticatedUserData = function()
  {
    // TODO fetch authenticated user profile (via header-meta hidden input??)

    let tmpProfile = {
      imageUrl: "./assets/images/avatars/avatar_default.png",
      fullName: "Clara Vlaeminck",
      linkedSchools: [

      ]
    };

    return new Promise((resolve, reject) =>
    {
      if(__DEVELOPMENT__ && false)
      {
        reject("brol");
      }
      else
      {
        resolve(tmpProfile);
      }
    });
  };

  UserServices.getUser = function()
  {
    return request.get({
      url: "/user",
      cache: false
    });
  }

  UserServices.getLoggedInUser = function()
  {
    return request.get({
      url: "/services/users/loggedin",
      cache: false
    });
  }

  UserServices.logout = function()
  {
    return request.get({
      url: "/logout",
      cache: false
    });
  };

  UserServices.deleteProfile = function()
  {
    return request.delete({
      url: utils.getServiceUrl("/users/delete_profile"),
      cache: false
    });
  }

  UserServices.authenticateUser = function(username, password)
  {
    // AuthenticateUserServlet functions as a proxy for /access/authenticate/password so we can force logout when a new authentication is requested
    return request.post({
      // url: "/access/authenticate/password",
      url: "/authenticate-user",
      cache: false,
      dataType: request.DATA_TYPES.TEXT,
      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        username: utils.isDefined(username) ? username : null,
        password: utils.isDefined(password) ? password : null
      }
    });
  };

  UserServices.requestPasswordReset = function(username)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/reset-password"),
      cache: false,
      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        username: username
      }
    })
      .then(UserServices.onServiceComplete);
  };

  UserServices.changePassword = function(data)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/change-password"),
      cache: false,
      data: {
        username: data.username,
        "password-old": data.passwordOld,
        "password-new": data.passwordNew,
        ticket: data.ticket
      }
    })
      .then(UserServices.onServiceComplete);
  };

  UserServices.getKeyForEmail = function(email)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/email"),
      cache: false,
      data: {
        email: email
      }
    })
      .then(UserServices.onServiceComplete);
  };

  UserServices.getUser = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/users/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then(UserServices.onServiceComplete);
  };

  UserServices.registerUser = function(userObj)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/register"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        username: userObj.username,
        password: userObj.password,
        firstname: userObj.firstname,
        lastname: userObj.lastname,
        gameboardCode: userObj.gameboardCode
      }
    }).then(UserServices.onServiceComplete);
  };

  UserServices.updateUserProfile = function(firstname, lastname)
  {
    return request.post({
      url: utils.getServiceUrl("/users/update_profile"),
      cache: false,
      data:
        {
          firstname: firstname,
          lastname: lastname,
        }
    }).then(UserServices.onServiceComplete);
  }

  UserServices.setAvatar = function(avatarKey)
  {
    return request.post({
      url: utils.getServiceUrl("/users/set_avatar"),
      cache: false,
      data:
        {
          avatar_key: avatarKey
        }
    }).then(UserServices.onServiceComplete);
  }

  UserServices.linkGameboard = function(email, code)
  {
    return request.post({
      url: utils.getServiceUrl("/users/link_gameboard"),
      cache: false,
      data:
        {
          email: email,
          gameboard_code: code
        }
    }).then(UserServices.onServiceComplete);
  }

  UserServices.unlinkGameboard = function()
  {
    return request.post({
      url: utils.getServiceUrl("/users/unlink_gameboard"),
      cache: false
    }).then(UserServices.onServiceComplete);
  }

  UserServices.changeGameboard = function(code)
  {
    return request.post({
      url: utils.getServiceUrl("/users/replace_gameboard"),
      cache: false,
      data:
        {
          gameboard_code: code
        }
    }).then(UserServices.onServiceComplete);
  }

  UserServices.onServiceComplete = function (data)
  {
    if(utils.isNotNull(data) && data.result === "success" && data.data)
    {
      return data.data;
    }

    return null;
  }

})(UserServices);

module.exports = UserServices;



// WEBPACK FOOTER //
// ./app/js/services/user-services.js